import { setHeader } from "@/util/set-header";
import { Icon,Toast } from "antd-mobile";
import React from "react";
import './change-store.less'
import { withRouter } from "react-router";
import { ReserveStoreListApi } from "@/api/sany";

// 处理IOS Webview上拉时
const touchmoveHandle = (e: any) => {
  e.preventDefault()
}
@(withRouter as any)
export default class ChangeStore extends React.Component<any, any> {
  constructor(prop: any) {
    super(prop)
    setHeader({
      title: '选择区域', leftClick: this.leftClick, right: this.rightBtn()
    })
    this.leftClick = this.leftClick.bind(this)
    this.setKey = this.setKey.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
    this.gitStoreList = this.gitStoreList.bind(this)
  }
  state = {
    cityName: sessionStorage.getItem('sanyCityName'),
    cityId: sessionStorage.getItem('sanyCityId'),
    content:'',
    cityList:[]
  }
  componentDidMount() {
    setHeader({ title: '选择园区', leftClick: this.leftClick, right: this.rightBtn() })
  }
  componentWillReceiveProps() {
    this.setState({
      cityName: sessionStorage.getItem('sanyCityName'),
      cityId: sessionStorage.getItem('sanyCityId'),
    }, async() => {
      await this.gitStoreList()
      setHeader({ title: '选择园区', leftClick: this.leftClick, right: this.rightBtn() })
    })
  }
  // 根据城市id获取园区名称
  gitStoreList() {
  let id = sessionStorage.getItem('sanyCityId')
  let name = this.state.content
    ReserveStoreListApi({region_id: id,store_name:name}).then((res:any)=>{
      if (res.data.code === 'SUCCESS') {
        this.setState({
          cityList: res.data.data
        })
      } else {
        Toast.info(res.data.msg)
      }
    })
  }
  leftClick() {
    this.props.history.push({
      pathname: '/sany/book-room',
      // state: {cityId: this.state.cityId, cityName: this.state.cityName}
    })
  }
  rightBtn() {
    return (
      <div style={{ display: 'flex', fontSize: '12px' }} onClick={() => this.jumpCityList()}>
        <div style={{ marginTop: '5px' }}  >{this.state.cityName}</div>
        <div><Icon type="down" /></div>
      </div>
    )
  }
  // 选择城市
  jumpCityList() {
    this.props.history.push({
      pathname: '/sany/change-area',
    })
  }
  // 选择园区
  changeStore() {
    return (
      <div className="search-body">
        <span className="search-body-input">
          <img src="/public/assets/img/search.png" alt="" />
          <input
            placeholder="请输入园区"
            onFocus={() => {
              document.body.addEventListener('touchmove', touchmoveHandle, {
                passive: false,
              })
            }}
            onBlur={() => {
              document.body.removeEventListener('touchmove', touchmoveHandle)
            }}
            onChange={({ target }: any) => this.setKey(target.value)}
            type="search"
            onKeyPress={this.onKeyPress}
          />
        </span>
      </div>
    )
  }
  // 获取输入值
  setKey(val:any) {
    this.setState({
      content:val
    })
    if(!val) {
      this.setState({
        content:''
      },async ()=>{
        await this.gitStoreList()
      })
    }
  }
  // 请求门店列表
  onKeyPress(event:any) {
    if (event.key === 'Enter') {
      this.gitStoreList()
    }
  }
  // 选择门店
  changeStoreName(val:any) {
    this.props.history.push({
      pathname: '/sany/book-room',
      // state: {storeId: val.id, storeName: val.name}
    })
    sessionStorage.setItem('sanyStoreId', val.id)
    sessionStorage.setItem('sanyStoreName',val.name)
  }
  // 城市列表
  cityList() {
      const list:any = this.state.cityList
      const arr:any = []
      list&&list.forEach((item:any,index:any) =>
        arr.push(
          <div key={index} style={{padding:'15px', borderBottom: '1px solid #eeeeee' }} onClick={() => this.changeStoreName(item)}>
            {item.name}
          </div>
          )
        )
      return arr
  }

  render() {
    return (
      <div className="city-list">
        {this.changeStore()}
        <div style={{ background:'#fff' }}>
          {this.cityList()}
        </div>
      </div>
    )
  }
}